import { Trans } from 'react-i18next';

interface DescriptionProps {
  translationKey: string;
}

export function Description({ translationKey }: DescriptionProps) {
  return (
    <div className="whitespace-pre-line text-foreground">
      <Trans
        i18nKey={translationKey}
        components={{ 1: <b />, 2: <ul className="my-4 list-disc pl-8" />, 3: <li /> }}
      />
    </div>
  );
}
